module.exports = __webpack_public_path__ + "img/cat.579a8238.png";